import styled, { css } from 'styled-components';

export const TitleAndProfile = styled.div`
  &:last-child {
    //? hack to avoid margin-collapse when there's no newsletter list
    border-bottom: 1px solid transparent;
  }
`;

export const PageTitle = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 32px;
  margin-bottom: 32px;

  h1:first-child {
    margin-right: auto;
  }

  label {
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
  }
`;

export const UserInfo = styled.div`
  display: flex;
  column-gap: 68px;
  margin-bottom: 48px;
`;

export const PicWrapper = styled.div`
  border: 5px solid #0056ac;
  border-radius: 50%;
  padding: 5px;
  width: fit-content;
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: flex-start; //prevent stretch
  margin-right: 68px; //column-gap

  @media ${(props) => props.theme.device.tablet} {
    margin-right: 0;
  }
`;

export const InputFile = styled.input`
  display: none;
`;

export const InfoBlockContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: auto 1fr 1fr 1fr;
  grid-template-rows: auto;
  grid-template-areas: 'avatar info-1 info-2 info-3';

  @media ${(props) => props.theme.device.tablet} {
    display: flex;
    flex-wrap: wrap;
    column-gap: 44px;
    row-gap: 32px;
  }
`;

export const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;

  .btns-wrapper {
    > button:last-child {
      margin-top: 10px;
    }

    .icon-log-out-01 {
      transform: rotate(180deg);
    }
  }

  &:nth-of-type(2) {
    grid-area: info-1;
    row-gap: 8px;
    padding-right: 12px;

    @media ${(props) => props.theme.device.tablet} {
      padding-right: 0;
    }
  }

  &:nth-of-type(3) {
    grid-area: info-2;
    border-left: 2px solid #d1d1d1;
    padding-left: 12px;
    padding-right: 12px;
    row-gap: 16px;

    @media ${(props) => props.theme.device.tablet} {
      padding-right: 0;
      width: 100%;
    }
  }

  &:nth-of-type(4) {
    grid-area: info-3;
    border-left: 2px solid #d1d1d1;
    padding-left: 12px;
    row-gap: 16px;

    @media ${(props) => props.theme.device.tablet} {
      width: 100%;
    }
  }
`;

export const SectionTitle = styled.div`
  padding: 1.4rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  cursor: pointer;
`;

export const InputContainer = styled.div`
  gap: 20px;
  justify-content: space-between;
  flex-wrap: wrap;
  display: none;

  ${({ showInput }) =>
    showInput &&
    css`
      display: flex;
    `}
`;

export const InputWrapper = styled.div`
  width: 340px;

  @media ${(props) => props.theme.device.mobileL} {
    width: 100%;
  }
`;

export const CardNewsletterGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 35px;
  margin-bottom: 64px;

  @media ${(props) => props.theme.device.tablet} {
    display: flex;
    flex-direction: column;
  }
`;
